import Vue from "vue";
import _ from "lodash";
import "@/lib/polyfills";
import "../../sass/vendor.scss";
import "../../sass/core.scss";
import "../../sass/financeApp.scss";

import FinanceIframe from "Modules/FinanceApp/FinanceIframe";
import MalRedirect from "Modules/FinanceApp/MalRedirect";
import FinanceApp from "Modules/FinanceApp";
import TestAppForm from "Modules/FinanceApp/TestAppForm";
import VueI18n from "vue-i18n";
import Vuex from "vuex";
import pathify from "@/store/pathify";
import user from "@/store/modules/user";
import translated from "@/store/modules/translated";
import location from "@/store/modules/location";
import campaign from "@/store/modules/campaign";
import sessionReset from "@/store/modules/sessionReset";
import headerTransitionStore from "@/store/modules/headerTransitionStore";
import CarSaverPlugin from "@/lib/CarSaverPlugin";

const environment = _.get(window, "appConfig.env[0]", "local") || "local";

Vue.use(Vuex);
Vue.use(VueI18n);

const debug = environment !== "production";

const store = new Vuex.Store({
    plugins: [pathify.plugin],

    modules: {
        user,
        translated,
        location,
        sessionReset,
        campaign,
        headerTransitionStore
    },
    strict: debug
});

const defaultMessages = _.get(store, "state.translated.text", {});
const messages = {
    default: defaultMessages,
    en: {},
    es: {}
};
const i18n = new VueI18n({
    locale: "default",
    fallbackLocale: "default",
    messages
});

Vue.use(CarSaverPlugin);

if (document.getElementById("root") != null) {
    // eslint-disable-next-line no-new
    new Vue({
        el: "#root",

        store,

        i18n,

        components: {
            FinanceIframe,
            FinanceApp,
            MalRedirect,
            TestAppForm
        }
    });
}
